import { useTranslation } from "react-i18next";
import i18n from "i18next";
const t = (key: string, fallback?: string) => i18n.t(key, fallback || key);
import React, { useEffect, useState } from "react";
import "./style.scss";
import { useNavigate, useParams } from "react-router-dom";
import _, { isEmpty } from "lodash";
import { useFilters } from "./Filters";
import { globalStore, useCoursesStore } from "../../../../stores/stores";
import useKeyword from "../../../../hooks/useKeyword";
import {
  CourseCardProps,
  CourseInfo,
  CoursePayload,
} from "../../../../types/course";
import {
  COURSE_SCHEDULE_TYPE,
  COURSE_TYPE,
  DEFAULT_PAGE_NUM,
  DEFAULT_PAGE_SIZE,
  FILTER_STAR_ARR,
  FREE_OPTIONS,
  PAID_VALUE_FILTER,
} from "../../../../constants";
import CourseCard from "../../../../components/card/CourseCard";
import { routesConfig } from "../../../../config/routes";
import {
  exportExcelCourse,
  getCoursesBlockQuiz,
} from "../../../../service/courses";
import {
  convertSomeObjKeyToArray,
  mapCourseInfoBeToFe,
} from "../../../../utils/format";
import {
  getArrayFilterChecked,
  getArrOrUndefined,
} from "../../../../utils/arrays";
import Filter from "../../../../components/filter";
import ResponsiveList from "../../../../components/list/ResponsiveList";
import CustomPagination from "../../../../components/list-program/pagination/Pagination";
import { Flex } from "antd";

function CourseUniversityInformation() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const params = useParams();

  const { industries } = useCoursesStore((state) => state);
  const { reload } = globalStore();
  const [keySearch, setKeySearch] = useState(useKeyword("keyword") || "");
  const [initialCourses, setInitialCourses] = useState<CourseCardProps[]>([]);
  const [courses, setCourses] = useState<CourseCardProps[]>([]);
  const [isShowMenuFilter, setIsShowMenuFilter] = useState<boolean>(true);

  const [pageSize, setPageSize] = useState<number>(20);
  const [pageNum, setPageNum] = useState<number>(DEFAULT_PAGE_NUM);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [searchValues, setSearchValues] = useState<CoursePayload>({
    sortByName: "asc",
  });
  const [loadingSearch, setLoadingSearch] = useState<boolean>(false);

  const topicId = Number(useKeyword("topic"));
  const university = params?.id || "";
  const keyword = useKeyword("keyword") || "";

  useEffect(() => {
    setSearchValues((prevState) => ({
      ...prevState,
      keyword: keyword,
    }));
    setKeySearch(keyword);
  }, [keyword]);

  useEffect(() => {
    if (university) {
      setSearchValues((prevState) => ({
        ...prevState,
        universities: [university],
      }));
    }
  }, [university]);

  const grid =
    isShowMenuFilter && !topicId
      ? { xs: 1, sm: 2, md: 2, lg: 3, xl: 3, xxl: 3 }
      : { xs: 1, sm: 2, md: 2, lg: 3, xl: 4, xxl: 4 };

  const filterMenus = useFilters({
    hasPaid: searchValues?.isFreeOptions?.includes(PAID_VALUE_FILTER)
      ? true
      : false,
  });

  const renderFilterMenuByParamsUrl = () => {
    if (university)
      return filterMenus.filter((item: any) => item?.key !== "university");

    return filterMenus;
  };

  useEffect(() => {
    if (topicId) {
      setSearchValues((prevState: any) => ({
        ...prevState,
        industries: [topicId],
      }));
    }
  }, [topicId]);

  useEffect(() => {
    const initialCourse = async () => {
      // Lấy danh sách khoá học
      const coursesInfo = await getCourses();
      setInitialCourses(renderCard(coursesInfo));
    };
    initialCourse();
  }, [reload]);

  useEffect(() => {
    if (
      isEmpty(searchValues) &&
      pageNum === DEFAULT_PAGE_NUM &&
      pageSize === DEFAULT_PAGE_SIZE
    )
      setCourses(initialCourses);
    else {
      // Lọc danh sách khoá học
      searchCourse();
    }
  }, [initialCourses, searchValues, pageNum, pageSize, reload]);

  const renderCard = (courses: any) => {
    if (!courses.length) return [];

    return courses.map((item: CourseCardProps) => ({
      content: (
        <CourseCard
          key={item.id}
          {...item}
          countAvatars={5}
          showTeacherAvatar
          isPopular={false}
          teachers={item.teachers?.filter(
            (teacher: string, index) => teacher !== " "
          )}
          onClick={() =>
            navigate(`${routesConfig.courseInfo}/detail/${item.id}`)
          }
        />
      ),
    }));
  };

  const getCourses = async (payload = {}) => {
    try {
      const res = await getCoursesBlockQuiz(payload);
      const coursesInfo = res.data.data.courses.map((item: CourseInfo) =>
        mapCourseInfoBeToFe(item)
      );
      setTotalRecords(res.data.data.total);
      return coursesInfo;
    } catch (err) {
      console.error(err);
      return [];
    }
  };

  const searchCourse = async () => {
    if (university)
      try {
        setLoadingSearch(true);
        const values = await getCourses({
          ...searchValues,
          page: pageNum,
          size: pageSize,
          keyword: keySearch.trim(),
        });
        setCourses(renderCard(values));
      } catch (err) {
      } finally {
        setTimeout(() => setLoadingSearch(false), 500);
      }
  };

  const handleChangeFilter = (value: any) => {
    // Filter chuyên ngành
    const industriesFilter = getArrayFilterChecked(
      industries,
      convertSomeObjKeyToArray(value, "industry"),
      "id"
    );
    // Xếp hạng
    const stars = getArrayFilterChecked(
      FILTER_STAR_ARR,
      convertSomeObjKeyToArray(value, "rank"),
      "value"
    );
    // Chi phí
    const freeOptions = getArrayFilterChecked(
      FREE_OPTIONS,
      convertSomeObjKeyToArray(value, "price"),
      "value"
    );

    // Filter lịch trình học
    const courseScheduleType = getArrayFilterChecked(
      COURSE_SCHEDULE_TYPE,
      convertSomeObjKeyToArray(value, "schedule"),
      "value"
    );
    // Filter loại khoá học
    const courseType = getArrayFilterChecked(
      COURSE_TYPE,
      convertSomeObjKeyToArray(value, "kindOfCourse"),
      "value"
    );
    const payload = {
      industries: getArrOrUndefined(industriesFilter),
      universities: [university],
      stars: getArrOrUndefined(stars),
      courseScheduleType: getArrOrUndefined(courseScheduleType),
      courseType: getArrOrUndefined(courseType),
      isFreeOptions: getArrOrUndefined(freeOptions),
      minCost: freeOptions?.includes(PAID_VALUE_FILTER) ? 0 : undefined,
      maxCost:
        freeOptions?.includes(PAID_VALUE_FILTER) && value?.cost
          ? value?.cost
          : freeOptions?.includes(PAID_VALUE_FILTER) && !value?.cost
          ? 0
          : undefined,
    };
    setPageNum(1);

    setSearchValues((prevState: CoursePayload) => ({
      ...prevState,
      ...payload,
    }));
  };

  const handleChangeSort = (value: number) => {
    switch (value) {
      case 1:
        setSearchValues((prevState: CoursePayload) => ({
          ...prevState,
          ...{ sortByName: "asc", sortByCreatedAt: undefined },
        }));
        break;
      case 2:
        setSearchValues((prevState: CoursePayload) => ({
          ...prevState,
          ...{ sortByName: "desc", sortByCreatedAt: undefined },
        }));
        break;
      case 3:
        setSearchValues((prevState: CoursePayload) => ({
          ...prevState,
          ...{ sortByCreatedAt: "desc", sortByName: undefined },
        }));
        break;
      case 4:
        setSearchValues((prevState: CoursePayload) => ({
          ...prevState,
          ...{ sortByCreatedAt: "asc", sortByName: undefined },
        }));
        break;
      default:
        break;
    }
  };

  const handleExportExcel = async () => {
    try {
      const res = await exportExcelCourse({
        ...searchValues,
        page: pageNum,
        size: pageSize,
        industryGroup: topicId || undefined,
      });
      const fileData = res.data;

      const blob = new Blob([fileData], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const downloadLink = document.createElement("a");
      downloadLink.href = URL.createObjectURL(blob);

      downloadLink.download = `${t("Danh sách khóa học", "Danh sách khóa học")}.xlsx`;

      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    } catch (error) {
      console.error("Error downloading Excel file:", error);
    }
  };

  return (
    <div className="courses-university-preview">
      <div className="container">
        <Flex className="mt-2 filter-content">
          {!topicId && (
            <Filter
              items={renderFilterMenuByParamsUrl()}
              onChange={handleChangeFilter}
              onChangeSort={handleChangeSort}
              onToggleCollapse={setIsShowMenuFilter}
            />
          )}

          <div className="content-list w-full-100">
            <ResponsiveList
              loading={loadingSearch}
              className="mt-5"
              showMenu={true}
              totalRecords={totalRecords}
              grid={grid}
              isViewReport={false}
              data={courses}
              onClickExportExcel={handleExportExcel}
              onClickReport={() => navigate(routesConfig.statisticsCourses)}
            />
            {totalRecords > 0 && (
              <CustomPagination
                totalPage={totalRecords}
                pageSize={pageSize}
                pageNumber={pageNum}
                setPageSize={(value) => setPageSize(value)}
                setPageNumber={(value) => setPageNum(value)}
              />
            )}
          </div>
        </Flex>
      </div>
    </div>
  );
}

export default CourseUniversityInformation;
